import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Stroke, Style } from "ol/style";

import { EDIT_LAYER_NAME } from "./constants";

export default function createEditLayer() {
  return new VectorLayer({
    // @ts-expect-error -  bad typing in ol custom prop are allowed
    name: EDIT_LAYER_NAME,
    // We don't put more because we are not sure how it affects the performance.
    renderBuffer: 500,
    source: new VectorSource({
      // [MAPSETW-446] To make sure we don't use the rbush tree.
      useSpatialIndex: false,
    }),
    style: new Style({
      stroke: new Stroke({
        color: [235, 0, 0],
        lineCap: "round",
        lineDash: [1, 10],
        width: 4,
      }),
    }),
    updateWhileAnimating: true,
    updateWhileInteracting: true,
    // [MAPSET-494] OL use this buffer value (in pixels) to find features to apply the hit detection on it.
    // 500 fit probably most of use cases (was 100 by default).
    zIndex: 100,
  });
}
